// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"38d08246","885":"cd124f8e"}[chunkId] + ".chunk.js";
};